<template>
  <v-container fluid align-start ma-0 pa-2 class="epmsa350-main container-height">
    <v-row no-gutters fill-height>
      <v-col cols="12">
        <i-card-vertical
          :headerTitle="menuTitle"
          :useBtnList="['btnRetrieve', 'btnExcel']"
          @btnRetrieve="btnRetrieve()"
          @btnExcel="onExporting()"
        >
          <template v-slot:body>
            <v-layout column overflow-auto>
              <v-row dense>
                <v-col cols="12" class="pa-0">
                  <i-card-top class="d-md-flex" outlined>
                    <template v-slot:body>
                      <v-row no-gutters class="center pa-2 pb-0">
                        <v-icon small color="blue">mdi-circle</v-icon>
                        <span class="pa-1 subTitle">Division : </span>
                        <v-col cols="2">
                          <v-select
                            v-model="division"
                            :items="divisionList"
                            item-text="name"
                            item-value="value"
                            outlined
                            dense
                            height="32"
                            @change="changeDivision()"
                          />
                        </v-col>

                        <i-label :label="'Ship No :'" class="pl-2" />
                        <v-col cols="2">
                          <v-autocomplete
                            v-model="shipNo"
                            :items="shipNoList"
                            outlined
                            dense
                            height="32"
                            clearable
                            @change="changeShipNo"
                          />
                        </v-col>

                        <i-label :label="'Lot No :'" class="pl-2" />
                        <v-col cols="1">
                          <v-autocomplete
                            v-model="lotNo"
                            :items="lotNoList"
                            outlined
                            dense
                            height="32"
                            clearable
                          />
                        </v-col>

                        <i-label :label="'Cut Group :'" class="pl-2" />
                        <v-col cols="1">
                          <v-autocomplete
                            v-model="cutGrp"
                            :items="cutGrpList"
                            outlined
                            dense
                            height="32"
                            clearable
                          />
                        </v-col>

                        <template v-if="isSummary">
                          <i-label :label="'Period Date :'" class="pl-2" />
                          <v-col cols="1">
                            <DxDateBox
                              :value="startDate"
                              height="32px"
                              display-format="yyyy-MM-dd"
                              :accept-custom-value="false"
                              @value-changed="setStartDate"
                            />
                          </v-col>
                          <span class="pa-1 subTitle">~</span>
                          <v-col cols="1">
                            <DxDateBox
                              :value="endDate"
                              height="32px"
                              display-format="yyyy-MM-dd"
                              :accept-custom-value="false"
                              @value-changed="setEndDate"
                            />
                          </v-col>
                        </template>
                      </v-row>
                    </template>
                  </i-card-top>
                </v-col>
              </v-row>

              <v-row no-gutters>
                <v-col cols="12" class="pt-1">
                  <DxDataGrid
                    id="epmsa350"
                    class="hipGridHeight1_1"
                    :ref="epmsa350Ref"
                    :data-source="gridMainList"
                    :remote-operations="false"
                    :hover-state-enabled="true"
                    :allow-column-resizing="true"
                    :allow-column-reordering="true"
                    :row-alternation-enabled="true"
                    :show-borders="true"
                    width="100%"
                    :show-row-lines="true"
                    key-expr="id"
                    :focused-row-enabled="true"
                    :column-hiding-enabled="false"
                    :selection="{ mode: 'none' }"
                    :sorting="{ mode: 'none' }"
                    @exporting="onExporting"
                  >
                    <DxEditing :use-icons="false"/>                    
                    <DxExport :enabled="true" />

                    <DxColumn data-field="rnum" caption="No" width="3%" alignment="center" :allow-editing="false" />
                    <DxColumn data-field="shipNo" caption="Ship No." width="6%" alignment="center" :allow-editing="false" />
                    <DxColumn data-field="lotNo" caption="Lot No." width="5%" alignment="center" :allow-editing="false" />
                    <DxColumn data-field="cutGrp" caption="Cut Group" width="5%" alignment="center" :allow-editing="false" />
                    <DxColumn data-field="pcsQty" caption="Pcs Qty" width="6%" data-type="number" format="#,##0" alignment="right" :allow-editing="false" />
                    <DxColumn data-field="cutQty" caption="Cut Qty" width="6%" data-type="number" format="#,##0" alignment="right" :allow-editing="false" />                    
                    <template #ppCuttingDate>
                          <div>PP Cutting<br />Date</div>
                    </template>
                    <template #dwgNo>
                          <div>Drawing<br />No.</div>
                    </template>
                    <template v-if="!isSummary">
                      <DxColumn data-field="midPsdDt" caption="PP Cutting Date" data-type="date" format="yyyy-MM-dd" width="10%" alignment="center" :allow-editing="false" header-cell-template="ppCuttingDate"/>                                         

                      <DxColumn data-field="dwgNo" caption="Drawing No." width="5%" alignment="center" :allow-editing="false" header-cell-template="dwgNo"/>
                     
                      <DxColumn data-field="markNo" caption="Mark No." width="9%" alignment="center" :allow-editing="false" />
                      <DxColumn data-field="woNo" caption="WO No." width="9%" alignment="center" :allow-editing="false" />
                      <DxColumn data-field="steelType" caption="Steel Type" width="9%" alignment="center" :allow-editing="false" />
                      <DxColumn data-field="cutDteDt" caption="Cut Date" data-type="date" format="yyyy-MM-dd" width="8%" alignment="center" :allow-editing="false" />
                      <DxColumn data-field="mixBlk" caption="Mix Block" width="5%" alignment="center" :allow-editing="false" />
                      <DxColumn data-field="machNm" caption="Machine" width="5%" alignment="center" :allow-editing="false" />
                      <DxColumn data-field="block" caption="Block" width="20%" alignment="center" :allow-editing="false" />
                    </template>
                    <template v-else>
                       <DxColumn data-field="diffQty" caption="Different Quantity" width="10%" alignment="center" :allow-editing="false" />
                       <DxColumn data-field="blank" caption="" width="6%" alignment="center" :allow-editing="false" />
                    </template>

                    <DxPaging :enabled="true" :page-size="20" />
                    <DxPager :allowed-page-sizes="[20, 'all']" />
                  </DxDataGrid>
                </v-col>
              </v-row>
            </v-layout>
          </template>
        </i-card-vertical>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { DxDataGrid, DxColumn, DxEditing, DxExport, DxPager, DxPaging } from 'devextreme-vue/data-grid'
import DxDateBox from 'devextreme-vue/date-box'
import { Workbook } from 'exceljs'
import { saveAs } from 'file-saver-es'
import { exportDataGrid } from 'devextreme/excel_exporter'
import ICardVertical from '@/components/common/iCardVertical.vue'
import iCardTop from '@/components/common/iCardTop.vue'
import baseview from '@/components/base/baseview.vue'
import BaseDataGrid from '@/components/base/BaseDataGrid.vue'
import { getDateFormat, getStringToDate } from '@/utils/common.js'
import { getShipNoList } from '@/api/view/hip/A/epmsa010_kl'
import { epmsa350CutGrp, epmsa350LotNo, epmsa350Detail, epmsa350Sum } from '@/api/view/hip/A/epmsa350'

export default {
  name: 'epmsa350',
  mixins: [baseview, BaseDataGrid],
  components: {
    ICardVertical,
    'i-card-top': iCardTop,
    DxDataGrid,
    DxColumn,
    DxEditing,
    DxDateBox,
    DxExport,
    DxPager,
    DxPaging
  },
  data() {
    return {
      menuTitle: this.$route.meta.title,
      epmsa350Ref: 'epmsa350Ref',
      makerCd: this.$store.state.user.makerCd,
      division: 'Detail',
      divisionList: [
        { name: 'Detail', value: 'Detail' },
        { name: 'Summary', value: 'Summary' }
      ],
      shipNo: '',
      shipNoList: [],
      lotNo: '',
      lotNoList: [],
      cutGrp: '',
      cutGrpList: [],
      startDate: null,
      endDate: null,
      gridMainList: []
    }
  },
  computed: {
    gridMainInstance() {
      return this.GetDataGrid(this.epmsa350Ref)
    },
    isSummary() {
      return this.division === 'Summary'
    }
  },
  mounted() {
    const today = new Date()
    this.startDate = new Date(today.getFullYear(), today.getMonth(), 1)
    this.endDate = new Date(today.getFullYear(), today.getMonth() + 1, 0)
    this.init()
  },
  methods: {
    async init() {
      try {
        this.openLoading('searching')
        await Promise.all([this.getShipNoList(), this.getCutGrpList()])
      } finally {
        this.endLoading()
      }
    },
    async getShipNoList() {
      const res = await getShipNoList({ makerCd: this.makerCd })
      this.shipNoList = ['']
      res.list.forEach(item => {
        this.shipNoList.push(item.shipNo)
      })
    },
    async getCutGrpList() {
      const res = await epmsa350CutGrp()
      this.cutGrpList = ['']
      res.list.forEach(item => {
        this.cutGrpList.push(item.cutGrp)
      })
    },
    async changeShipNo() {
      this.lotNo = ''
      this.lotNoList = ['']

      if (!this.shipNo) {
        return
      }

      const res = await epmsa350LotNo({ shipNo: this.shipNo })
      this.lotNoList = ['']
      res.list.forEach(item => {
        this.lotNoList.push(item.lotNo)
      })
    },
    setStartDate(e) {
      this.startDate = e.value
    },
    setEndDate(e) {
      this.endDate = e.value
    },
    changeDivision() {
      this.gridMainList = []
    },
    getParams() {
      return {
        shipNo: this.shipNo || '',
        lotNo: this.lotNo || '',
        cutGrp: this.cutGrp || '',
        stDte: getDateFormat(this.startDate),
        edDte: getDateFormat(this.endDate)
      }
    },
    async btnRetrieve() {
      if (!this.shipNo) {
        this.vToastify('Please select Ship No.', 'warn')
        return
      }

      if (this.isSummary && (!this.startDate || !this.endDate)) {
        this.vToastify('Please select Period Date.', 'warn')
        return
      }

      this.gridMainList = []
      try {
        this.openLoading('searching')
        const params = this.getParams()
        const res = this.isSummary ? await epmsa350Sum(params) : await epmsa350Detail(params)
                
        this.gridMainList = res.list.map((item, index) => ({
          ...item,
          id: index + 1,
          rnum: index + 1,
          diffQty: item.pcsQty - item.cutQty, 
          midPsdDt: !this.isSummary && item.midPsd ? getStringToDate(item.midPsd) : null,
          cutDteDt: !this.isSummary && item.cutDte ? getStringToDate(item.cutDte) : null
        }))
      } finally {
        console.log('main list : ', this.gridMainList)
        this.endLoading()
      }
    },
    onExporting(e) {
      const workbook = new Workbook()
      const worksheet = workbook.addWorksheet(this.isSummary ? 'Summary' : 'Detail')

      exportDataGrid({
        component: this.gridMainInstance,
        worksheet,
        topLeftCell: { row: 3, column: 1 }
      }).then(() => {
        const titleRow = worksheet.getRow(1)
        const conditionRow = worksheet.getRow(2)
        const headerRow = worksheet.getRow(3)
        const lastColumn = Math.max(headerRow.cellCount, 1)
        const period = this.isSummary ? ` / Period Date: ${getDateFormat(this.startDate)} ~ ${getDateFormat(this.endDate)}` : ''

        worksheet.mergeCells(1, 1, 1, lastColumn)
        worksheet.mergeCells(2, 1, 2, lastColumn)
        titleRow.getCell(1).value = 'Steel Cutting Status'
        titleRow.getCell(1).font = { name: 'Segoe UI Light', size: 18, bold: true }
        titleRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle' }
        conditionRow.getCell(1).value = `Division: ${this.division} / Ship No: ${this.shipNo || 'All'} / Lot No: ${this.lotNo || 'All'} / Cut Group: ${this.cutGrp || 'All'}${period}`
        conditionRow.getCell(1).alignment = { horizontal: 'left', vertical: 'middle' }

        const fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'DFE3D5' } }
        const border = {
          left: { style: 'thin', color: { argb: 'BFBFBF' } },
          right: { style: 'thin', color: { argb: 'BFBFBF' } },
          top: { style: 'thin', color: { argb: 'BFBFBF' } },
          bottom: { style: 'thin', color: { argb: 'BFBFBF' } }
        }

        worksheet.eachRow((row, rowNumber) => {
          row.eachCell(cell => {
            cell.border = border
            if (rowNumber === 3) {
              cell.fill = fill
              cell.alignment = { horizontal: 'center', vertical: 'middle' }
            }
          })
        })
      }).then(() => workbook.xlsx.writeBuffer()).then(buffer => {
        saveAs(new Blob([buffer], { type: 'application/octet-stream' }), `CuttingPerformance_${this.division}.xlsx`)
      })

      if (e) {
        e.cancel = true
      }
    }
  }
}
</script>

<style scoped>
.subTitle {
  font-weight: bold;
  color: black;
}
</style>